"use client";

import Image from "next/image";
import Link from "next/link";
import { type ExtendedRecordMap } from "notion-types";
import React, { type AnchorHTMLAttributes } from "react";
import { NotionRenderer } from "react-notion-x";

type NotionContentProps = {
  recordMap: ExtendedRecordMap;
  className?: string;
  pageSlug?: string;
};

export const NotionContent: React.FC<NotionContentProps> = ({
  recordMap,
  className,
  pageSlug,
}) => {
  return (
    <NotionRenderer
      className={"!bg-transparent !px-0 " + className}
      recordMap={recordMap}
      darkMode={false}
      isImageZoomable={false}
      components={{
        nextImage: Image,
        nextLink: Link,
        PageLink: (props: AnchorHTMLAttributes<HTMLAnchorElement>) => (
          <NotionPageLink {...props} pageSlug={pageSlug} />
        ),
      }}
    />
  );
};

const NotionPageLink = ({
  href,
  pageSlug,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> &
  Pick<NotionContentProps, "pageSlug">) => {
  const innerPageSectionId = href?.split("#")[1];

  if (!pageSlug || !innerPageSectionId) {
    return <a href={href} {...props} />;
  }
  return <a href={`/${pageSlug}#${innerPageSectionId}`} {...props} />;
};
